<template>
    <div :class="`custom-marker ${value.selected ? 'selected' : ''}  ${this.isHover ? 'hover' : ''}`">
        <div class="content-area">
            <h4 v-if="!value.selected" class="nowrap more currency" style="color: black">+ {{value.price}} &euro;</h4>
            <h6 v-else class="currency mb-0 nowrap" style="cursor: pointer!important">{{value.name.substring(0, 30)}}...</h6>
        </div>
        <div class="square">
        </div>
    </div>
</template>

<script>
export default {
  name: 'CustomServiceMarker',
  props: {
    value: Object,
    hover: Object
  },
  data () {
    return {
      isHover: false
    }
  },
  watch: {
    hover () {
      if (this.hover && this.value.item) {
        this.isHover = this.hover.anagrafica.element.productID === this.value.item.anagrafica.element.productID
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/google-map/CustomServiceMarker.vue